// Carrega TODAS as páginas de uma listagem da API de entidades (que limita o tamanho da página,
// ~500 registros). Pagina até vir uma página vazia ou sem nenhum registro novo (protege contra
// servidor que ignora `page` e contra limite menor que o pedido). Devolve no mesmo formato de
// uma resposta do apiClient ({ data: { data: { data: [...] } } }) para reaproveitar os normalizadores.
//
// Uso: await carregarTodasPaginas((page, limit) => service.getAll(page, limit, "", "", null, null, null, "code"))
export async function carregarTodasPaginas(buscarPagina, { pageSize = 500, maxPaginas = 200 } = {}) {
  const todos = []
  const vistos = new Set()

  for (let page = 1; page <= maxPaginas; page++) {
    const resposta = await buscarPagina(page, pageSize)
    const lista = resposta?.data?.data?.data || resposta?.data?.data || resposta?.data || []
    if (!Array.isArray(lista) || lista.length === 0) break

    let novos = 0
    for (const item of lista) {
      const chave = item?.id ?? item?._id
      if (chave === undefined || chave === null) {
        todos.push(item)
        novos++
      } else if (!vistos.has(chave)) {
        vistos.add(chave)
        todos.push(item)
        novos++
      }
    }
    if (novos === 0) break
  }

  return { data: { data: { data: todos } } }
}
